// Renders a tier-specific label positioned over the phone screen area of the product image.
// Uses a dark backing plate to mask any pre-existing text baked into the image.

const TIER_STYLES = {
  degoogled: {
    label: "DEGOOGLED",
    fontClass: "font-degoogled",
    color: "#EAEAEA",
    // subtle google-style multi-color under-accent
    tint: "linear-gradient(90deg,#4285F4 0%,#EA4335 25%,#FBBC05 50%,#34A853 75%,#4285F4 100%)",
  },
  secure: {
    label: "SECURE",
    fontClass: "font-secure",
    color: "#EAEAEA",
    tint: "none",
  },
  phantom: {
    label: "PHANTOM",
    fontClass: "font-phantom",
    color: "#7C3AED",
    tint: "none",
  },
};

/**
 * Positioning is percentage-based over the image container so it lands roughly
 * over the phone-screen area across our 10 renders.
 *
 * @param {'degoogled'|'secure'|'phantom'} tier
 * @param {'sm'|'md'|'lg'} size — visual scale
 */
export default function TierScreenText({ tier, size = "lg" }) {
  const s = TIER_STYLES[tier];
  if (!s) return null;

  const sizes = {
    sm: "text-lg md:text-2xl px-3 py-1.5",
    md: "text-3xl md:text-4xl px-5 py-2",
    lg: "text-4xl md:text-6xl px-6 md:px-10 py-3 md:py-4",
  }[size];

  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-[28%] flex justify-center z-20"
      data-testid={`tier-screen-${tier}`}
    >
      <div
        className={`relative ${sizes} uppercase ${s.fontClass}`}
        style={{ color: s.color, backgroundColor: "rgba(3,3,3,0.86)", backdropFilter: "blur(2px)" }}
      >
        <span className="relative z-10">{s.label}</span>
        {tier === "degoogled" && (
          <div
            className="absolute left-3 right-3 -bottom-[3px] h-[3px] opacity-90"
            style={{ background: s.tint, mixBlendMode: "screen" }}
          />
        )}
        {tier === "secure" && (
          <>
            <span className="absolute -left-2 top-1/2 -translate-y-1/2 w-1 h-1 bg-[#EAEAEA]" />
            <span className="absolute -right-2 top-1/2 -translate-y-1/2 w-1 h-1 bg-[#EAEAEA]" />
          </>
        )}
      </div>
    </div>
  );
}
